// removed by extract-text-webpack-plugin
module.exports = {"search-container":"piP12Tm-s0do2NBAom3_D","search-header":"_3oTfHKOd_oTMjG83ov6spN","search-button":"_3o4VXe-sXl2wXdVruX6XTk","clear-button":"_2tYqpgqmr2R9BN6Mr0mO","cancel-button":"_1cJIsm4gtpud8NgvvoPZyS"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/SearchUsers/styles.css
// module id = 1609
// module chunks = 0